import { Dispatch, SetStateAction } from 'react';
import {
  WIDGETS_FIELDS,
  HpIdFieldConfigType,
  createLogger,
  PreffixLogs
} from '@uma/react-commons/dist/index';
import { LoginDetailsType } from 'src/components/LoginDetails';

export interface HpIdMFAType {
  enabled: boolean;
  pending_mfa: {
    qr_code: string;
    totp_url: string;
    state: string;
  };
}

export const getFieldsToFetchProfile = (
  setLoginDetails: Dispatch<SetStateAction<LoginDetailsType>>
): HpIdFieldConfigType[] => {
  const logger = createLogger({
    preffix: PreffixLogs.SECURITY,
    context: 'ActiveSessions'
  });
  return [
    {
      field: WIDGETS_FIELDS.EMAIL,
      setter: (value: string) =>
        setLoginDetails((prev) => ({ ...prev, email: value })),
      propertySelector: 'value'
    },
    {
      field: WIDGETS_FIELDS.EMAIL,
      setter: (value: string) =>
        setLoginDetails((prev) => ({
          ...prev,
          emailVerified: String(value).toLowerCase() === 'true'
        })),
      propertySelector: 'verified'
    },
    {
      field: WIDGETS_FIELDS.PHONE,
      setter: (value: string) =>
        setLoginDetails((prev) => ({ ...prev, phone: value }))
    },
    {
      field: WIDGETS_FIELDS.PHONE,
      setter: (value: string) =>
        setLoginDetails((prev) => ({
          ...prev,
          phoneVerified: String(value).toLowerCase() === 'true'
        })),
      propertySelector: 'verified'
    },
    {
      field: WIDGETS_FIELDS.USERNAME,
      setter: (value: string) => {
        setLoginDetails((prev) => ({ ...prev, username: value }));
      }
    },
    {
      field: WIDGETS_FIELDS.MFA,
      setter: (value: string) => {
        if (!value || typeof value !== 'string' || !isValidJson(value)) {
          logger.warn('Invalid MFA value: Value is not a valid JSON string');
          setLoginDetails((prev) => ({
            ...prev,
            mfa: null
          }));
          return;
        }

        const parseValue: HpIdMFAType = JSON.parse(value);
        parseValue.enabled =
          String(parseValue.enabled).toLowerCase() === 'true';

        setLoginDetails((prev) => ({
          ...prev,
          mfa: parseValue.enabled
        }));
      }
    }
  ];
};

export function isValidJson(value: string): boolean {
  try {
    JSON.parse(value);
    return true;
  } catch {
    return false;
  }
}

export const getFieldsToFetchActiveSessions = (
  setLoginDetails: Dispatch<SetStateAction<LoginDetailsType>>
): HpIdFieldConfigType[] => {
  return [
    {
      field: WIDGETS_FIELDS.SESSIONS,
      setter: (value: any) =>
        setLoginDetails((prev) => ({ ...prev, sessionInfo: value }))
    }
  ];
};
